import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex row items-center" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = {
  key: 0,
  class: "reward_amount"
}
const _hoisted_4 = {
  key: 1,
  class: "reward_amount"
}
const _hoisted_5 = {
  class: "col-12 q-py-lg q-px-md table-mobile-even-bg",
  style: {"border-top":"1px solid var(--border-color)","background":"#FBFBFB"}
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 flex items-center" }
const _hoisted_8 = { class: "additional-text q-mr-sm" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-lg" }, null, -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-6 q-mb-md" }
const _hoisted_12 = { class: "additional-text q-mr-sm" }
const _hoisted_13 = { class: "col-6 q-mb-md" }
const _hoisted_14 = { class: "additional-text q-mr-sm" }
const _hoisted_15 = { class: "col-6 q-mb-md" }
const _hoisted_16 = { class: "additional-text q-mr-sm" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "col-6 q-mb-md" }
const _hoisted_20 = { class: "additional-text q-mr-sm" }
const _hoisted_21 = { class: "col-6 q-mb-md" }
const _hoisted_22 = { class: "additional-text q-mr-sm" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "reward_amount" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "col-6 q-mb-md" }
const _hoisted_27 = { class: "additional-text q-mr-sm" }
const _hoisted_28 = {
  key: 1,
  class: "reward_amount"
}
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "additional-text q-mr-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Filters = _resolveComponent("Filters")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Filters, {
          onReset: _ctx.resetFilters,
          onChange: _ctx.onChangeFilters,
          onChangeAll: _ctx.changeAll,
          onExport: _ctx.exportCsv,
          "current-filters": _ctx.filters
        }, null, 8, ["onReset", "onChange", "onChangeAll", "onExport", "current-filters"])
      ])
    ]),
    _createVNode(_component_q_table, {
      rows: _ctx.rows,
      columns: _ctx.columns,
      "row-key": "id",
      separator: "cell",
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
      loading: _ctx.loading,
      onRequest: _ctx.onRequest,
      "binary-state-sort": "",
      "column-sort-order": "da",
      flat: "",
      grid: _ctx.$q.screen.width <= 1199
    }, _createSlots({
      "body-cell-holdAmount": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            (
            props.row.reason === _ctx.transactionReasons.LeadHold ||
              (props.row.reason === _ctx.transactionReasons.RefBonusPaymentHold &&
                props.row.rewardType !== _ctx.rewardTypes.RevShare)
          )
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(props.row.transactionAmount) + " " + _toDisplayString(_ctx.currencies[props.row.transactionCurrency]), 1))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" — ")
                ], 64))
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-transactionAmount": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            (
            props.row.reason === _ctx.transactionReasons.LeadHold ||
              props.row.reason === _ctx.transactionReasons.RefBonusPaymentHold
          )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" — ")
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.getFormattedValue(props.row.transactionAmount)) + " " + _toDisplayString(_ctx.currencies[props.row.transactionCurrency]), 1))
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 2
    }, [
      (_ctx.$q.screen.width <= 1199)
        ? {
            name: "item",
            fn: _withCtx((props) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('date')) + ":", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.format(props.row.datetime)), 1)
                  ])
                ]),
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('offer')) + ":", 1),
                    _createElementVNode("div", null, _toDisplayString(props.row.offerName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('status')) + ":", 1),
                    _createElementVNode("div", null, _toDisplayString(props.row.offerName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('labels')) + ":", 1),
                    (props.row.trafficProperty)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(props.row.trafficProperty), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, "—"))
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('income_revshare')) + ": ", 1),
                    _createElementVNode("div", null, _toDisplayString(props.row.rewardType === _ctx.rewardTypes.RevShare &&
                props.row.reason === _ctx.transactionReasons.LeadHold
                  ? `${_ctx.getFormattedValue(props.row.transactionAmount)} ${
                      _ctx.currencies[props.row.transactionCurrency]
                    }`
                  : '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('income_hold')) + ":", 1),
                    (
                props.row.reason === _ctx.transactionReasons.LeadHold ||
                  (props.row.reason ===
                    _ctx.transactionReasons.RefBonusPaymentHold &&
                    props.row.rewardType !== _ctx.rewardTypes.RevShare)
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.getFormattedValue(props.row.transactionAmount)) + " " + _toDisplayString(_ctx.currencies[props.row.transactionCurrency]), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_25, "—"))
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('pass_balance')) + ":", 1),
                    (
                props.row.reason === _ctx.transactionReasons.LeadHold ||
                  props.row.reason === _ctx.transactionReasons.RefBonusPaymentHold
              )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" — ")
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.getFormattedValue(props.row.transactionAmount)) + " " + _toDisplayString(_ctx.currencies[props.row.transactionCurrency]), 1))
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('conversion_id')) + ": ", 1),
                    _createElementVNode("div", null, _toDisplayString(props.row.leadId), 1)
                  ])
                ])
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["rows", "columns", "pagination", "loading", "onRequest", "grid"])
  ], 64))
}